<template>
    <div class="m-3">
        <b-card no-body class="shadow">
            <b-tabs card small>
                <b-tab no-body>
                    <template #title>
                        <div v-b-tooltip.hover.right title="Filtrar por fecha">
                            <b-icon icon="calendar2-check"></b-icon>
                        </div>
                    </template>

                    <FilterDate class="m-2 ms-3"></FilterDate>
                </b-tab>

                <b-tab no-body title="Filtrar por rol">
                    <template #title>
                        <div v-b-tooltip.hover.right title="Filtrar por rol">
                            <b-icon icon="person-badge"></b-icon>
                        </div>
                    </template>

                    <FilterRole class="m-2"></FilterRole>
                </b-tab>

            </b-tabs>
        </b-card>
    </div>
</template>
<script>
import FilterDate from './FilterUser/Filter-date.vue'
import FilterRole from './FilterUser/Filter-rol.vue'

export default {
    name: 'FilterUser',

    components:{
        FilterDate,
        FilterRole
    }

}
</script>
<style></style>
